import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PageTitleText: FunctionComponent<Props> = props => {
    const { children = props.text, className = '', testId = TEST_ID } = props;

    return (
        <p className={`${className} ${styles.pageTitleText}`} data-testid={testId}>
            {children}
        </p>
    );
};

export default PageTitleText;
